module.exports = __webpack_public_path__ + "img/matrics_landing-page_image.2ebdea43.png";